import { List } from 'immutable'
import { recentDate } from 'app/utils/faker'

export const messages = function(currentUser, orgUsers, conversationId, endUserId = 1) {
  let createdAt = recentDate()

  return List([
    {
      "id": 336611,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Got it! Thanks for entering your phone number.",
      "uuid": "36b8628a-ca1f-438a-b246-2342a1a1b850",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Got it! Thanks for entering your phone number.",
        "isBot": true,
        "interactionId": 1252,
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336610,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": endUserId,
      "replyToId": 0,
      "authorType": "END_USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "5555555555",
      "uuid": "3cc40e4c-ab08-4013-94bb-ef4893206598",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "8603046131",
        "interactionId": 1252,
        "questionId": "b386b3a9-1138-4121-8f63-122606d38cbc",
        "sentOfflineHours": false,
        "widgetGuid": "db53bae6-ea50-4d49-8e13-e7e99a6638da",
        "clientTimestamp": 1517929957830,
        "integrations": {},
        "botClassification": 15
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": {
        "campaign": {},
        "ip": "144.121.21.2",
        "locale": "en",
        "location": {
          "city": "Boston",
          "region": "Massachusetts",
          "country": "US",
          "countryName": "United States",
          "postalCode": "02116",
          "latitude": 42.3496,
          "longitude": -71.0746
        },
        "os": {
          "name": "OS X 10.13.2",
          "version": "10.13.2",
          "family": "OS X",
          "architecture": "32"
        },
        "page": {
          "path": "/home",
          "referrer": "",
          "search": "",
          "title": "Drift",
          "url": "app.driftqa.com/home",
          "href": "https://app.driftqa.com/home"
        },
        "timezone": "America/New_York",
        "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
      },
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336262,
      "inboxId": 1,
      "type": "CONVERSATION_EVENT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "",
      "uuid": "bc313775-ecb0-4c49-ac87-eedc388cb0e0",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": {
        "type": "CQL_UPDATED",
        "cqlscore": 3,
        "cqlsource": "BOT"
      },
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "",
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CONVERSATION_EVENT",
      "context": {
        "ip": "52.204.75.158",
        "location": {
          "city": "Ashburn",
          "region": "Virginia",
          "country": "US",
          "countryName": "United States",
          "postalCode": "20149",
          "latitude": 39.0481,
          "longitude": -77.4728
        }
      },
      "recipientStatuses": {},
      "viewerRecipientStatus": null
    },
    {
      "id": 336260,
      "inboxId": 1,
      "type": "CONVERSATION_EVENT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "",
      "uuid": "6aa9741f-7b16-4fc4-bbac-1f069d8322d3",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": {
        "type": "CONVERSATION_CLASSIFIED",
        "authorUserIdType": "USER",
        "currentParticipantIds": [
          7412
        ],
        "createdAt": 1517856900255,
        "classificationId": "shFwhtNs9Dbw"
      },
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "",
        "botClassification": 1
      },
      "deliveryChannel": null,
      "contentType": "CONVERSATION_EVENT",
      "context": null,
      "recipientStatuses": {},
      "viewerRecipientStatus": null
    },
    {
      "id": 336259,
      "inboxId": 1,
      "type": "CONVERSATION_EVENT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "",
      "uuid": "5e0a663f-1137-4e49-9109-ce0cb8e6cf9b",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": {
        "type": "GOAL_REACHED",
        "authorUserIdType": "USER",
        "currentParticipantIds": [
          7412
        ],
        "createdAt": 1517856840140,
        "playbookId": 3359,
        "goalId": "7cc1e6c3-acc0-4ec4-9081-3e75540fef4c"
      },
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "",
        "botClassification": 1
      },
      "deliveryChannel": null,
      "contentType": "CONVERSATION_EVENT",
      "context": null,
      "recipientStatuses": {},
      "viewerRecipientStatus": null
    },
    {
      "id": 336258,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Great!",
      "uuid": "8da6bca9-0425-47ef-949e-c2039a9c625d",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Great!",
        "isBot": true,
        "interactionId": 1252,
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336257,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": endUserId,
      "replyToId": 0,
      "authorType": "END_USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Definitely",
      "uuid": "ddca4f9d-afdc-4dc4-bb6b-9679ef14d8ea",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Definitely",
        "interactionId": 1252,
        "questionId": "92db5f61-79c0-4356-84dc-52cae06c9315",
        "buttonClicked": true,
        "sentOfflineHours": false,
        "widgetGuid": "4c7d6ac6-9373-4428-8b1e-a10f517e02c8",
        "clientTimestamp": 1517856802392,
        "integrations": {},
        "botClassification": 15
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": {
        "campaign": {},
        "ip": "146.115.89.231",
        "locale": "en",
        "location": {
          "city": "Boston",
          "region": "Massachusetts",
          "country": "US",
          "countryName": "United States",
          "postalCode": "02116",
          "latitude": 42.3496,
          "longitude": -71.0746
        },
        "os": {
          "name": "OS X 10.13.2",
          "version": "10.13.2",
          "family": "OS X",
          "architecture": "32"
        },
        "page": {
          "path": "/home",
          "referrer": "",
          "search": "",
          "title": "Drift",
          "url": "app.driftqa.com/home",
          "href": "https://app.driftqa.com/home"
        },
        "timezone": "America/New_York",
        "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
      },
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336256,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Want to learn more and setup a call with somebody from our team?",
      "uuid": "17cc778a-96a9-4668-8dac-1c0492be4291",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Want to learn more and setup a call with somebody from our team?",
        "isBot": true,
        "interactionId": 1252,
        "buttons": [
          {
            "label": "Definitely",
            "value": "Definitely"
          },
          {
            "label": "No",
            "value": "No"
          }
        ],
        "questionId": "92db5f61-79c0-4356-84dc-52cae06c9315",
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336255,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Sounds good",
      "uuid": "99fc9ef0-443e-4f80-9e9b-0cf4e1375751",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Sounds good",
        "isBot": true,
        "interactionId": 1252,
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336254,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": endUserId,
      "replyToId": 0,
      "authorType": "END_USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "No",
      "uuid": "893ba727-bf1e-4c82-a948-9857c38756d2",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "No",
        "interactionId": 1252,
        "questionId": "934ae907-e43e-4d6b-927c-4bdec58a79ca",
        "buttonClicked": true,
        "sentOfflineHours": false,
        "widgetGuid": "7f5a2da1-07bd-41b0-ad52-f93330f4f8d1",
        "clientTimestamp": 1517856798750,
        "integrations": {},
        "botClassification": 15
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": {
        "campaign": {},
        "ip": "146.115.89.231",
        "locale": "en",
        "location": {
          "city": "Boston",
          "region": "Massachusetts",
          "country": "US",
          "countryName": "United States",
          "postalCode": "02116",
          "latitude": 42.3496,
          "longitude": -71.0746
        },
        "os": {
          "name": "OS X 10.13.2",
          "version": "10.13.2",
          "family": "OS X",
          "architecture": "32"
        },
        "page": {
          "path": "/home",
          "referrer": "",
          "search": "",
          "title": "Drift",
          "url": "app.driftqa.com/home",
          "href": "https://app.driftqa.com/home"
        },
        "timezone": "America/New_York",
        "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
      },
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336253,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Are you already using a product/service like ours?",
      "uuid": "c2247dda-a2fb-4faf-958c-fc7d0910f4fa",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Are you already using a product/service like ours?",
        "isBot": true,
        "interactionId": 1252,
        "buttons": [
          {
            "label": "Yes",
            "value": "Yes"
          },
          {
            "label": "No",
            "value": "No"
          }
        ],
        "questionId": "934ae907-e43e-4d6b-927c-4bdec58a79ca",
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336252,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Awesome!",
      "uuid": "0b44b6d8-8329-4be2-8ee0-8465f9807628",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Awesome!",
        "isBot": true,
        "interactionId": 1252,
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336250,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": endUserId,
      "replyToId": 0,
      "authorType": "END_USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Want to talk to sales",
      "uuid": "696b17ac-7d04-4bf5-96c1-2cfee2b9860d",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Want to talk to sales",
        "interactionId": 1252,
        "questionId": "f75362a3-6dfe-4541-8f2e-406cae37e302",
        "buttonClicked": true,
        "sentOfflineHours": false,
        "widgetGuid": "45035fa2-047a-4a00-ac75-6746f018e4fb",
        "clientTimestamp": 1517856789861,
        "integrations": {},
        "botClassification": 15
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": {
        "campaign": {},
        "ip": "146.115.89.231",
        "locale": "en",
        "location": {
          "city": "Boston",
          "region": "Massachusetts",
          "country": "US",
          "countryName": "United States",
          "postalCode": "02116",
          "latitude": 42.3496,
          "longitude": -71.0746
        },
        "os": {
          "name": "OS X 10.13.2",
          "version": "10.13.2",
          "family": "OS X",
          "architecture": "32"
        },
        "page": {
          "path": "/home",
          "referrer": "",
          "search": "",
          "title": "Drift",
          "url": "app.driftqa.com/home",
          "href": "https://app.driftqa.com/home"
        },
        "timezone": "America/New_York",
        "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
      },
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336249,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 15860,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Welcome to Drift Staging! What brought you here to check us out?",
      "uuid": "ec493c5b-2402-49d3-97fe-23a23f1f720d",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Welcome to Drift! What brought you here to check us out?",
        "isBot": true,
        "interactionId": 1252,
        "buttons": [
          {
            "label": "Want to talk to sales",
            "value": "Want to talk to sales"
          },
          {
            "label": "Just Browsing",
            "value": "Just Browsing"
          }
        ],
        "questionId": "f75362a3-6dfe-4541-8f2e-406cae37e302",
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336248,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 15860,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "Hey there!",
      "uuid": "f5a24dcb-7156-4f77-802b-5b26d60dfd14",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "Hey there!",
        "isBot": true,
        "interactionId": 1252,
        "botClassification": 1
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": null,
      "recipientStatuses": {
        "END_USER:1023273": "Read",
        "USER:18458": "Read"
      },
      "viewerRecipientStatus": "Read"
    },
    {
      "id": 336247,
      "inboxId": 1,
      "type": "CHAT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": endUserId,
      "replyToId": 0,
      "authorType": "END_USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "",
      "uuid": "976d9ad4-4e7f-4ced-882a-2b9b8e52d665",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": null,
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "",
        "accountId": "18074430-91ae-4ec6-a2dd-281bcb7442d1",
        "withGreeting": true,
        "interactionId": 1252,
        "autoAssigneeId": 7412,
        "sentOfflineHours": false,
        "widgetGuid": "aaed324a-5caa-44c5-9aef-e93cd62f5ced",
        "startInteraction": 1252,
        "clientTimestamp": 1517856762730,
        "integrations": {},
        "botClassification": 15
      },
      "deliveryChannel": "CHAT",
      "contentType": "CHAT",
      "context": {
        "campaign": {},
        "ip": "146.115.89.231",
        "locale": "en",
        "location": {
          "city": "Boston",
          "region": "Massachusetts",
          "country": "US",
          "countryName": "United States",
          "postalCode": "02116",
          "latitude": 42.3496,
          "longitude": -71.0746
        },
        "os": {
          "name": "OS X 10.13.2",
          "version": "10.13.2",
          "family": "OS X",
          "architecture": "32"
        },
        "page": {
          "path": "/home",
          "referrer": "",
          "search": "",
          "title": "Drift",
          "url": "app.driftqa.com/home",
          "href": "https://app.driftqa.com/home"
        },
        "timezone": "America/New_York",
        "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
      },
      "recipientStatuses": {
        "END_USER:1023273": "Read"
      },
      "viewerRecipientStatus": null
    },
    {
      "id": 336246,
      "inboxId": 1,
      "type": "CONVERSATION_EVENT",
      "orgId": 1,
      "tags": [],
      "cc": [],
      "bcc": [],
      "conversationId": conversationId,
      "customerId": 0,
      "authorId": 101,
      "replyToId": 0,
      "authorType": "USER",
      "to": null,
      "from": null,
      "subject": null,
      "body": "",
      "uuid": "b0d0e630-5600-46b2-b613-2aecb42f7433",
      "originalHtml": null,
      "originalText": null,
      "conversationEvent": {
        "type": "ADDED_PARTICIPANTS",
        "authorUserIdType": "USER",
        "conversationStatus": "BULK_SENT",
        "participantIds": [
          7412
        ],
        "currentParticipantIds": [
          7412
        ],
        "participantChangeType": "DIRECT",
        "createdAt": 1517856763030
      },
      "attachments": [],
      "createdAt": createdAt -= 10000,
      "updatedAt": createdAt,
      "layerUrl": null,
      "attributes": {
        "preview": "",
        "botClassification": 1
      },
      "deliveryChannel": null,
      "contentType": "CONVERSATION_EVENT",
      "context": null,
      "recipientStatuses": {},
      "viewerRecipientStatus": null
    },
  ])
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/demodata.js